import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState } from "@/components/common/EmptyState";
import { KpiPeriodCard } from "@/components/workspace/KpiPeriodCard";
import { ResourceList } from "@/components/workspace/ResourceList";

export function TeamKpisTab({ orgId, meId, canEdit, onChanged }) {
  const [kpis, setKpis] = useState(null);
  const load = () => api.get(`/workspace/team/kpis?org_id=${orgId}`).then((r) => setKpis(r.data));
  useEffect(() => { load(); }, [orgId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!kpis) return <Icons.Loader2 className="mx-auto mt-8 animate-spin text-[#FFB000]" />;
  if (!kpis.length) return <EmptyState icon="Gauge" title="No team KPIs" description="KPIs owned by people in your team appear here by reporting period." testId="team-kpis-empty" />;
  return (
    <div className="space-y-4" data-testid="team-kpis-tab">
      <p className="text-sm text-[#1E2D44]/60">A period with no result shows as <b>Not reported</b> — never as zero. Status always comes from the actual value against the target.</p>
      {kpis.map((k) => (
        <KpiPeriodCard key={k.id} kpi={k} meId={meId} canRecord={canEdit} canVerify={canEdit} canRequest={canEdit} onChanged={() => { load(); onChanged(); }} />
      ))}
    </div>
  );
}

export function TeamResourcesTab({ orgId, canAdmin }) {
  const [items, setItems] = useState(null);
  const load = () => api.get(`/workspace/resources?org_id=${orgId}`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [orgId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items) return <Icons.Loader2 className="mx-auto mt-8 animate-spin text-[#FFB000]" />;
  return <ResourceList orgId={orgId} resources={items} canAdmin={canAdmin} canManage onChanged={load} />;
}
